import { DataSource, HorizontalSpacer, Image, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutServiceIncidentQuickInfo extends Layout {
    horizontalspacer1: HorizontalSpacer;
    imageLink: Image;
    labelServiceIncident: Label;
    sourceServicefailStopUser: DataSource;
    tableServiceIncidents: Table;
}
